import { memo, useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getFullUrl } from 'hubspot-url-utils';
import { SALES_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { SALES_PROFESSIONAL } from 'self-service-api/constants/UpgradeProducts';
import { MERCH_CARD } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import * as upgradeTracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { BUY_TOUCHLESS, TRIAL } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';
import { getPurchaseMotions } from '../../../clients/monetizationClient';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const getPricingPageUrl = () => `/pricing/${PortalIdParser.get()}/`;
const FetchStates = {
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const TrialButton = /*#__PURE__*/memo(({
  upgradeData
}) => /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
  purchaseMotions: [TRIAL],
  level: 1,
  upgradeData: upgradeData,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-ui-apps-core.installButton.purchaseMotions.trial"
  })
}));
const PurchaseMotionButton = ({
  fallback
}) => {
  const app = 'market-place-ui';
  const upgradeData = {
    app,
    screen: 'detail',
    uniqueId: 'connect-button',
    apiName: SALES_HUB_PROFESSIONAL,
    upgradeProduct: SALES_PROFESSIONAL
  };
  const [purchaseMotion, setPurchaseMotion] = useState();
  const [fetchState, setFetchState] = useState(FetchStates.loading);
  const [showTooltip, setShowTooltip] = useState(true);
  const handleBuyClick = () => {
    upgradeTracker.track('interaction', {
      action: 'clicked interstitial redirect',
      screen: 'detail',
      upgradeProduct: SALES_PROFESSIONAL
    });
    const interstitialUrl = `${getFullUrl('app')}${getPricingPageUrl()}interstitial?products=sales-hub-professional_1`;
    window.open(interstitialUrl, '_blank');
  };
  const handleTrialClick = () => {
    setShowTooltip(false);
  };
  useEffect(() => {
    getPurchaseMotions({
      location: [MERCH_CARD],
      apiName: [SALES_HUB_PROFESSIONAL]
    }).then(purchaseMotionData => {
      var _purchaseMotionData$l;
      const purchaseMotions = (_purchaseMotionData$l = purchaseMotionData.locations) === null || _purchaseMotionData$l === void 0 || (_purchaseMotionData$l = _purchaseMotionData$l[MERCH_CARD]) === null || _purchaseMotionData$l === void 0 || (_purchaseMotionData$l = _purchaseMotionData$l.purchaseMotions) === null || _purchaseMotionData$l === void 0 ? void 0 : _purchaseMotionData$l[SALES_HUB_PROFESSIONAL].map(obj => obj.key);
      if (purchaseMotions.includes(TRIAL)) {
        setPurchaseMotion(TRIAL);
      } else if (purchaseMotions.includes(BUY_TOUCHLESS)) {
        setPurchaseMotion(BUY_TOUCHLESS);
      }
      setFetchState(FetchStates.success);
    }).catch(() => {
      setFetchState(FetchStates.error);
    });
  }, []);
  if (fetchState === FetchStates.loading) {
    return null;
  } else if (fetchState === FetchStates.error) {
    return fallback;
  }
  if (purchaseMotion === TRIAL) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.installButton.purchaseMotions.tooltip"
      }),
      disabled: !showTooltip,
      children: /*#__PURE__*/_jsx("span", {
        onClick: handleTrialClick,
        children: /*#__PURE__*/_jsx(TrialButton, {
          upgradeData: upgradeData
        })
      })
    });
  }
  if (purchaseMotion === BUY_TOUCHLESS) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.installButton.purchaseMotions.tooltip"
      }),
      children: /*#__PURE__*/_jsx(Button, {
        onClick: handleBuyClick,
        use: "primary",
        target: "_blank",
        truncate: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.installButton.purchaseMotions.buyTouchless"
        })
      })
    });
  }
  return fallback;
};
export default PurchaseMotionButton;